import { CsvPayload } from '../../common/models/CsvPayload';

export class OrganizationCsvData {
  constructor(
    private readonly overview: CsvPayload,
    private readonly trends: CsvPayload,
    private readonly inventory: CsvPayload,
    private readonly issues: CsvPayload
  ) {}

  getOverview() {
    return this.overview;
  }

  getTrends() {
    return this.trends;
  }

  getInventory() {
    return this.inventory;
  }

  getIssues() {
    return this.issues;
  }
}
